<template>
    <div class="app-wrapper" :class="{hideSidebar:!sidebar.opened}">

        <el-tooltip effect="light" :disabled=toggleMer :visible-arrow=false placement="right" popper-class='tooltip_toggle' :class="[{ 'width100': isShrinkage }]">
            <div slot="content" @click="switchSystem"><img src="../../assets/imgs/switch.png" alt="" class="switch-img" /></div>
            <div class="menu-logo" index='top'>
                <div class="menu-logo-wrapper unipay-div" :style="companyId != 2 ?'top:0;z-index:2000':'top:-78px;z-index:1'">
                    <img src="../../assets/imgs/qbt.png" :class="['logo-img',{'logo-shrink-img':isShrinkage}]" />
                    <div :class="['divide-line',{'hide-el':isShrinkage}]"></div>
                    <div :class="['logo-system',{'hide-el':isShrinkage}]">Unipay</div>
                </div>

                <div v-if="whiteLabel=='N' || whiteLabel == 'undefined'" class="menu-logo-wrapper mipay-div" :style="companyId == 2?'top:0;z-index:2000':'top:-78px;z-index:1'">
                    <img src="../../assets/imgs/miPay.png" :class="['logo-img',{'logo-shrink-img':isShrinkage}]" />
                    <div :class="['divide-line',{'hide-el':isShrinkage}]"></div>
                    <div :class="['logo-system',{'hide-el':isShrinkage}]">MiPay</div>
                </div>
            </div>
        </el-tooltip>

        <sidebar :class="['sidebar-container', { 'sidebar-container-shrinkage': isShrinkage }]"></sidebar>

        <div class="menu-toggle" index='bottom' :class="[{ 'width100': isShrinkage }]">
            <svg aria-hidden="true" class="svg-icon svg-slide-icon" @click="toggleSildeBar">
                <use xlink:href="#icon-hamburger"></use>
            </svg>
        </div>

        <navbar></navbar>
        <div :class="['main-container', { 'main-container-shrinkage': isShrinkage }]">
            <app-main v-if="isRouterAlive"></app-main>
        </div>
    </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "views/layout";

export default {
    name: "layout",
    data() {
        return {
            toggleMer: true,
            active_id: undefined,
            companyId: localStorage.getItem("companyId"),
            whiteLabel:localStorage.getItem('whiteLabel'),
        };
    },
    components: {
        Navbar,
        Sidebar,
        AppMain
    },
    created() {
        this.toggleMer =
            localStorage.getItem("phone") == "13501189583" ||
            localStorage.getItem("phone") == "15018955912"
                ? false
                : true;
    },
    computed: {
        sidebar() {
            return this.$store.state.app.sidebar;
        },
        isShrinkage() {
            return this.$store.state.app.isShrinkage;
        },
        isRouterAlive() {
            return this.$store.state.app.isRouterAlive;
        }
    },
    methods: {
        toggleSildeBar() {
            const _that = this;
            this.$store.commit("TOGGLE_SHRINKAGE");
            if (this.$store.state.app.isShrinkage) {
                $(".el-submenu__title i").hide();
                $(".svg-slide-icon").css("transform", "rotateZ(90deg)");
            } else {
                $(".el-submenu__title i").show();
                $(".svg-slide-icon").css("transform", "rotateZ(0deg)");
            }
            setTimeout(function() {
                for (let i = 0; i < $(".switch-el-menu-item").length; i++) {
                    $(".switch-el-menu-item")[i].classList.remove("is-active");
                }
                if (
                    _that.$route.path == "/handleMer" ||
                    _that.$route.path == "/handleShop"
                ) {
                    $("#merchant").addClass("is-active");
                } else if ( _that.$route.path == "/handleaAgent" ) {
                    $("#agent").addClass("is-active");
                } else if ( _that.$route.path == "/handleFirm" ) {
                    $("#firm").addClass("is-active");
                } else if ( _that.$route.path == "/editNotify" ) {
                    $("#notify").addClass("is-active");
                } else if ( _that.$route.path == "/shopAuditDetails" || _that.$route.path == '/shopAuditRecord' ) {
                    $("#shopAudit").addClass("is-active");
                } else if ( _that.$route.path == "/agentAuditDetails" || _that.$route.path == '/agentAuditRecord' ) {
                    $("#agentAudit").addClass("is-active");
                } else if ( _that.$route.path == "/merAuditDetails" || _that.$route.path == '/merAuditRecord' ) {
                    $("#merAudit").addClass("is-active");
                } else if ( _that.$route.path == "/firmAuditDetails" || _that.$route.path == '/firmAuditRecord' ) {
                    $("#firmAudit").addClass("is-active");
                } else if ( _that.$route.path == "/ruleSettings" ) {
                    $("#riskControl").addClass("is-active");
                } else {
                    $("#" + _that.$route.path.replace("/", "")).addClass(
                        "is-active"
                    );
                }

            }, 300);
        },

        switchSystem() {
            const _that = this;
            if ($(".unipay-div").css("top") == "0px") {
                localStorage.setItem("companyId", "2");
                // 切换miPay
                $(".mipay-div").css({
                    "box-shadow": "0 2px 3px rgba(0,0,0,.23)",
                    "z-index": "2000"
                });
                $(".unipay-div").css({ "z-index": "1" });
                $(".mipay-div").animate({ top: "0px" }, function() {
                    $(".mipay-div").css("box-shadow", "none");
                    $(".unipay-div").css("top", "-78px");
                    _that.$store.commit("TOGGLE_ROUTERALIVE");
                    _that.$nextTick(() =>
                        _that.$store.commit("TOGGLE_ROUTERALIVE")
                    );
                });

                setTimeout(function() {
                    _that.$router.push({ path: "/welcome" });
                    location.reload();
                }, 1000);
            } else {
                localStorage.setItem("companyId", "1");
                // 切换Unipay
                $(".unipay-div").css({
                    "box-shadow": "0 2px 3px rgba(0,0,0,.23)",
                    "z-index": "2000"
                });
                $(".mipay-div").css("z-index", "1");
                $(".unipay-div").animate({ top: "0px" }, function() {
                    $(".unipay-div").css("box-shadow", "none");
                    $(".mipay-div").css("top", "-78px");
                    _that.$store.commit("TOGGLE_ROUTERALIVE");
                    _that.$nextTick(() =>
                        _that.$store.commit("TOGGLE_ROUTERALIVE")
                    );
                });
                setTimeout(function() {
                    _that.$router.push({ path: "/welcome" });
                    location.reload();
                }, 1000);
            }
        }
    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";

// 切换侧边栏
.menu-toggle {
    position: fixed;
    bottom: 0;
    left: 0;
    border-left: none;
    height: 70px;
    width: 223px;
    line-height: 70px;
    text-align: right;
    background-color: #5272e9;
    cursor: auto;
    z-index: 1999;
    transition: width 0.28s ease-out;
}

// 切换机构
.switch-img {
    width: 45px;
    height: 45px;
    cursor: pointer;
}
.menu-logo-wrapper {
    overflow: hidden;
    &::after {
        background-color: transparent;
    }
}
.menu-logo {
    height: 78px;
    background: rgba(82, 114, 233, 1);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    border-left: none;
    color: #fff;
    overflow: hidden;
    margin-bottom: 4px;
    position: fixed;
    width: 223px;
    z-index: 1999;
    top: 0;
    transition: width 0.28s ease-out;

    .unipay-div,
    .mipay-div {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        background-color: #5272e9;
        padding-left: 14px;
        // box-shadow: 0 2px 3px rgba(0,0,0,.23);
    }

    .mipay-div {
        // top: -78px;
    }

    .logo-img {
        float: left;
        width: 50px;
        height: 50px;
        margin: 14px 6px;
    }
    .logo-shrink-img {
        margin-right: 27px;
        margin-left: 10px;
    }
    .divide-line {
        float: left;
        width: 1px;
        height: 33px;
        margin: 22px 7px 22px 0px;
        background-color: #fff;
        &::after {
            background-color: transparent;
        }
    }
    .logo-system {
        float: left;
        font-size: 36px;
        color: #fff;
        line-height: 78px;
        &::after {
            background-color: transparent;
        }
    }
}

.app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    // background-color:#f0f0f0;
    &.hideSidebar {
        .sidebar-container {
            width: 100px;
            overflow: inherit;
        }
        .main-container {
            margin-left: 36px;
        }
    }
    .sidebar-container {
        transition: width 0.28s ease-out;
        background-color: rgba(82, 114, 233, 1);
        color: rgba(255, 255, 255, 1);
        border-right: 0;
        width: 223px;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 1001;
        overflow: auto;
        height: 85%;
        margin-top: 78px;
        &::-webkit-scrollbar {
            display: none;
        }
        box-shadow: 0px 1px 6px 1px rgba(45, 63, 130, 0.39);
        padding-bottom: 70px;
    }
    .sidebar-container-shrinkage {
        width: 100px;
        overflow: auto;
    }
    .main-container {
        min-height: 100%;
        transition: margin-left 0.28s ease-out;
        margin: 78px 0 0 223px;
    }
    .main-container-shrinkage {
        margin: 78px 0 0 100px;
    }
}
.slide-btn {
    color: #fff;
    position: fixed;
    bottom: 0;
    left: 178px;
    background-color: #4964cf;
    z-index: 10002;
    width: 45px;
    height: 45px;
    border: 0;
}
</style>



// WEBPACK FOOTER //
// Layout.vue?3932fe29